import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import $ from 'jquery';
import { InputinstalasihdPage } from '../inputinstalasihd/inputinstalasihd';
import { KomisioningroPage } from '../komisioningro/komisioningro';
import { KomisioninghdPage } from '../komisioninghd/komisioninghd';

/**
 * Generated class for the ProginstalasiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-proginstalasi',
  templateUrl: 'proginstalasi.html',
})
export class ProginstalasiPage {

  datawo: any;
  datamesin: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams
    ) {
      this.datawo = this.navParams.get('datawo');
      this.getData();
      this.datamesin = JSON.parse(localStorage.getItem('datamesin'));
      console.log(this.datamesin);
  }

  ionViewDidLoad() {
    // console.log(this.datawo);
  }

  getData(){
    $.ajax({
      url: "http://35.240.151.223:43209/newapimobile/get-data-instalasi-mesin/108WO061912",
      type: "get",
      dataType: 'json',
      success: function (result) {
        var pesan = result.pesan;
        var data = result.data;
        localStorage.removeItem('datamesin');
        localStorage.setItem('datamesin', JSON.stringify(data));
      }
    });
  }

  inputHD(param){
    let data = {
      "nomesin": param.nomesin,
      "nowo": this.datawo.nowo
    }
    this.navCtrl.push(KomisioninghdPage, data);
  }

  inputRO(param){
    let data = {
      "nomesin": param.nomesin,
      "nowo": this.datawo.nowo
    }
    this.navCtrl.push(KomisioningroPage, data);
  }

  getStatusMesin(param){
    var nowo = nowo;
  }

}



// WEBPACK FOOTER //
// ./src/pages/proginstalasi/proginstalasi.ts